<template>
  <div
    v-if="isEditor"
    class="component-slot-placeholder"
    :data-slot-name="fields.name || 'default'"
  >
    <slot />
    <div v-if="isEmpty" class="slot-empty-label">Slot: {{ fields.name || 'default' }}</div>
  </div>
  <slot v-else-if="!isEmpty" />
</template>

<script setup lang="ts">
import { useSlots, computed } from 'vue'
import { PipeDisplayMode, usePipe } from '@render/composables/usePipe'
import type { ComponentSlotFields } from './definition'

defineProps<{
  fields: ComponentSlotFields
}>()

const slots = useSlots()
const isEmpty = computed(() => !slots.default || slots.default().length === 0)

const pipe = usePipe()
const isEditor = computed(() => pipe.currentMode.value === PipeDisplayMode.EDITOR)
</script>

<style scoped>
.component-slot-placeholder {
  min-height: 32px;
  border: 1.5px dashed #8b5cf6;
  border-radius: 6px;
  padding: 4px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.slot-empty-label {
  color: #8b5cf6;
  font-size: 0.7rem;
  text-align: center;
  padding: 4px 8px;
  opacity: 0.7;
  user-select: none;
}
</style>
